// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"90c8d67e","455":"8c2f131f","977":"b7707e39"}[chunkId] + ".chunk.js";
};